import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Modal, Tooltip, Tag, DatePicker, Button, Row, Card } from 'antd';
import PageTitle from '../../components/PageTitle';
import TableActionBar from '../../components/TableActionBar';
import _, { } from 'lodash';
import qs from 'qs';
import { Form } from '@ant-design/compatible';
import TextTruncate from 'react-text-truncate';
import { checkPermission } from '../../utils/permission';
import { cleanObject, stripHtml, isValidDate, ConvertPaymentMethod } from '../../utils/helpers';
import HtmlParser from 'react-html-parser';
import NumberFormat from 'react-number-format';
import BaseSelect from '../../components/Elements/BaseSelect';
import moment from 'moment';
import { getListBranchFunds, getSpecificBranchFunds, removeBranchFunds } from '../../redux/actions/BranchFundActions';
import { EyeOutlined, ReloadOutlined } from '@ant-design/icons';
import { getBranchActive } from '../../redux/actions/BranchActions';
import BranchFundForm from './BranchFundForm';
import BranchFundDetail from './BranchFundDetail';
import StatisticNumber from '@/components/StatisticNumber';

const { confirm } = Modal;
const { RangePicker } = DatePicker;

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/branch-funds',
        breadcrumbName: 'Phiếu nhập quỹ',
    },
]

class BranchFundList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedRowKeys: [],
            isOpenForm: false,
            currentItem: null,
            isOpenDetail: false
        }
    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({ isLoading: true });
        this.props.getListBranchFunds(query).then(() => {
            this.setState({ isLoading: false });
        });
        this.props.getBranchActive();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.setState({ isLoading: true });
            this.props.getListBranchFunds(query).then(() => {
                this.setState({
                    isLoading: false
                })
            })
        }
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }
        if (name === 'created_at') {
            if (value && value.length > 0) {
                query.created_date_start = moment(value[0]).format('YYYY-MM-DD');
                query.created_date_end = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.created_date_start;
                delete query.created_date_end;
            }
        }
        if (name === 'receipt_date') {
            if (value && value.length > 0) {
                query.receipt_date_start = moment(value[0]).format('YYYY-MM-DD');
                query.receipt_date_end = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.receipt_date_start;
                delete query.receipt_date_end;
            }
        }
        delete query.created_at;
        delete query.receipt_date;
        query = cleanObject(query);
        //console.log("query: ", query)
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    toggleOpenForm(isOpenForm, currentItem = null) {
        this.setState({ isOpenForm: isOpenForm, currentItem: currentItem });
    }

    onEdit(id) {
        this.props.getSpecificBranchFunds(id).then(res => {
            this.toggleOpenForm(true, res);
        })
    }

    onRemove() {
        this.props.removeBranchFunds(this.state.selectedRowKeys).then(() => {
            this.setState({
                selectedRowKeys: []
            });
            setTimeout(() => {
                Modal.destroyAll();
            }, 800);
            this.reloadData();
        })
    }
    openAlert(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá những bản ghi này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.removeBranchFunds([id]).then(() => {
                setTimeout(() => {
                    Modal.destroyAll();
                }, 800);
                this.reloadData();
            }),
            onCancel() { },
        })
    }

    toggleOpenDetail(isOpenDetail, data = null) {
        this.setState({ isOpenDetail: isOpenDetail, currentItem: data });
    }

    onDetail(id) {
        this.setState({ current_id: id })
        this.props.getSpecificBranchFunds(id).then(res => {
            this.toggleOpenDetail(true, res);
        })
    }

    reloadData() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({ isLoading: true });
        this.props.getListBranchFunds(query).then(() => {
            this.setState({ isLoading: false });
        })
    }


    render() {
        var { branch_funds_list, pagination,
            users, branchActiveList, summary
        } = this.props;
        var { isLoading, selectedRowKeys,
            isOpenForm,
            currentItem, isOpenDetail,
            current_id
        } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const hasSelected = selectedRowKeys.length > 0;
        var query = qs.parse(this.props.location.search.slice(1));

        const columns = [

            {
                title: '#',
                align: 'center',
                width: '40px',
                render: (text, record) => {
                    if (text) {
                        if (checkPermission('branch_fund', 'detail')) {
                            return (
                                <Tooltip title="Xem chi tiết phiếu" placement="right">
                                    <div className='color-primary item-action-btn' onClick={() => this.onDetail(record.id)}>
                                        <EyeOutlined />
                                    </div>
                                </Tooltip>
                            )
                        } else {
                            return (
                                <>
                                    <EyeOutlined style={{ color: '#dedede' }} />
                                </>
                            )
                        }
                    }
                }
            },
            {
                title: 'Tên phiếu',
                dataIndex: 'name',
                key: 'name'
            },
            {
                title: 'Tổng tiền',
                dataIndex: 'amount',
                key: 'amount',
                sorter: true,
                width: '140px',
                render: (text, record) => (
                    <NumberFormat value={text} displayType={'text'} thousandSeparator={true} />
                )
            },
            {
                title: 'Ghi chú',
                dataIndex: 'note',
                key: 'note',
                width: '200px',
                render: (text, record) => {
                    return (
                        <div style={{ wordBreak: "break-word" }}>
                            <Tooltip title={HtmlParser(text)} placement="topLeft">
                                <TextTruncate line={1} truncateText="…" text={stripHtml(text)} />
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                title: 'Cơ sở',
                dataIndex: 'branche',
                key: 'branche',
                width: '100px',
                render: (text, record) => {
                    return (
                        <>{record.branche?.name}</>
                    )
                }
            },
            {
                title: 'Phương thức TT',
                dataIndex: 'payment_method',
                key: 'payment_method',
                width: '130px',
                render: (text, record) => {
                    return (
                        <>{ConvertPaymentMethod(text)}</>
                    )
                }
            },
            {
                title: 'Ngày nhập quỹ',
                dataIndex: 'receipt_date',
                key: 'receipt_date',
                width: '150px',
                sorter: true,
                render: (text, record) => {
                    if (text && text !== '') {
                        return (
                            <>{isValidDate(text, false)}</>
                        )
                    } else {
                        return (<Tag></Tag>)
                    }
                }
            },
            {
                title: 'Ngày tạo',
                dataIndex: 'created_at',
                key: 'created_at',
                width: '150px',
                sorter: true,
                render: (text, record) => {
                    if (text && text !== '') {
                        return (
                            <>{isValidDate(text)}</>
                        )
                    } else {
                        return (<Tag>N/A</Tag>)
                    }
                }
            },
            {
                title: 'Người tạo',
                dataIndex: 'created_user',
                key: 'created_user',
                width: '200px',
                sorter: true
            }
        ];

        return (
            <div>
                <PageTitle routes={routes} title="Phiếu nhập quỹ" />
                <div>
                    <TableActionBar
                        isShowAddButton={checkPermission('branch_fund', 'create')}
                        isShowDeleteButton={checkPermission('branch_fund', 'remove')}
                        onAdd={() => this.toggleOpenForm(true)}
                        onDelete={() => this.onRemove()}
                        disabled={!selectedRowKeys.length ? true : false}
                        showFilter={true}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                        placeholderSearch="Mã phiếu, người nhận tiền"
                        activeFilter={
                            query.created_date_start ||
                            query.created_user_id ||
                            query.payment_method ||
                            query.branch_id
                        }
                        filters={
                            [
                                <BaseSelect
                                    options={branchActiveList || []}
                                    optionValue="id"
                                    optionLabel="name"
                                    placeholder="Chọn cơ sở"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('branch_id', value)}
                                    defaultValue={query.branch_id ? parseInt(query.branch_id) : null}
                                />,
                                <RangePicker
                                    format="DD/MM/YYYY"
                                    placeholder={['Ngày nhập quỹ', 'đến ngày']}
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('receipt_date', value)}
                                    defaultValue={[query.receipt_date_start ? moment(query.receipt_date_start, 'YYYY-MM-DD') : null, query.receipt_date_end ? moment(query.receipt_date_end, 'YYYY-MM-DD') : null]}
                                />,
                                <RangePicker
                                    format="DD/MM/YYYY"
                                    placeholder={['Ngày tạo', 'đến ngày']}
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('created_at', value)}
                                    defaultValue={[query.created_date_start ? moment(query.created_date_start, 'YYYY-MM-DD') : null, query.created_date_end ? moment(query.created_date_end, 'YYYY-MM-DD') : null]}
                                />,
                                <BaseSelect
                                    options={users || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Người tạo"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('created_user_id', value)}
                                    defaultValue={query.created_user_id ? parseInt(query.created_user_id) : null}
                                />
                            ]
                        }
                    >
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.reloadData()}>Refresh</Button>
                        {
                            hasSelected ? <span>Đang chọn {selectedRowKeys.length} bản ghi</span> : ''
                        }
                    </TableActionBar>
                </div>
                <Row gutter={16} className="mb-2" justify="space-between" style={{ margin: 0 }}>
                    <Card className="branch-statistic">
                        <StatisticNumber
                            title="Tổng quỹ nhập"
                            value={summary?.TongQuyNhap || 0}
                            precision={0}
                            unit="đ"
                        />
                    </Card>
                    <Card className="branch-statistic">
                        <StatisticNumber
                            title="Tổng quỹ chi"
                            value={summary?.ChiTrongNgay || 0}
                            precision={0}
                            unit="đ"
                        />
                    </Card>
                    <Card className="branch-statistic">
                        <StatisticNumber
                            title="Quỹ tồn"
                            value={summary?.TonQuyChi || 0}
                            precision={0}
                            unit="đ"
                        />
                    </Card>
                </Row>
                <Table
                    rowKey="id"
                    size="small"
                    tableLayout='auto'
                    dataSource={branch_funds_list || []}
                    columns={columns}
                    loading={isLoading}
                    rowSelection={rowSelection}
                    pagination={{
                        pageSize: pagination.perPage,
                        current: pagination.currentPage,
                        total: pagination.total,
                        showTotal: total => `Tổng ${total} bản ghi`,
                        defaultPageSize: 30, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '40', '50', '100', '200']
                    }}
                    onChange={(pagination, filters, sorter) => this.onChangeTable(pagination, sorter)}
                    scroll={{
                        x: 'max-content'
                    }}
                />
                <BranchFundForm
                    visible={isOpenForm}
                    currentItem={currentItem}
                    reloadData={() => this.reloadData()}
                    onCancel={() => this.toggleOpenForm(false)}
                />
                <BranchFundDetail
                    visible={isOpenDetail}
                    currentItem={currentItem}
                    reloadData={() => { this.onDetail(current_id); this.reloadData() }}
                    onCancel={() => this.toggleOpenDetail(false)}
                    loadingDetail={false}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        branch_funds_list: state.BranchFundReducer.branch_funds_list,
        pagination: state.BranchFundReducer.pagination,
        summary: state.BranchFundReducer.summary,
        users: state.config.users,
        branchActiveList: state.BranchReducer.branchActiveList,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getListBranchFunds: (filter) => dispatch(getListBranchFunds(filter)),
        getSpecificBranchFunds: (id) => dispatch(getSpecificBranchFunds(id)),
        removeBranchFunds: (ids) => dispatch(removeBranchFunds(ids)),
        getBranchActive: () => dispatch(getBranchActive()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'BranchFundList' })(BranchFundList));

